import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { hideModal } from '../../actions/modal'
import { manuallyChangePoolStatus, MANUALLY_CHANGE_POOL_STATUS } from '../../actions/manuallyChangePoolStatus'
import ModalComponent from '../../components/modal/index'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'
import { capitalizeFirstLetter } from '../../helpers/string'

export class ManuallyChangePoolStatusModal extends React.Component {

  constructor() {
    super()
    this.manuallyChangePoolStatus = this.manuallyChangePoolStatus.bind(this)
  }

  isManuallyOfflineNow() {
    return (this.props.offlineEvents || []).some(x => x.eventType === "Manual")
  }

  isOfflinedByEtaNow() {
    return (this.props.offlineEvents || []).some(x => x.eventType === "PoolEta")
  }

  shouldShowManualOverrideWarning() {
    return !this.isManuallyOfflineNow() && this.isOfflinedByEtaNow()
  }

  manuallyChangePoolStatus() {
    this.props.manuallyChangePoolStatus(this.props.poolId, this.isManuallyOfflineNow())
  }

  render() {
    if (this.props.isOpen && this.props.modalType === MANUALLY_CHANGE_POOL_STATUS) {

      const newStatus = this.isManuallyOfflineNow() ? 'online' : 'offline'
      const manualOverrideTooltip = 'If you offline it manually, it will NOT be auto-onlined when the courier capacity goes below the upper threshold of courier capacity, and you will need to make it online manually, as manual actions override system actions.'
      const poolName = this.props.poolName || this.props.poolId
      const showManualOverrideWarning = this.shouldShowManualOverrideWarning()

      const body = showManualOverrideWarning
        ? (
          <div className="manual-status-warning">
            <div className="manual-status-warning__headline">
              <span className="manual-status-warning__headline-copy">
                This pool <mark>{poolName}</mark> is already offlined automatically due to the courier capacity.
              </span>
              <span
                data-toggle="tooltip"
                data-placement="top"
                data-container="body"
                className="icon-questionmark manual-status-warning__icon"
                title={manualOverrideTooltip}/>
            </div>
            <div>Are you sure you want to <b>manually</b> offline the pool?</div>
          </div>
        )
        : (
          <div style={{lineHeight: "2em"}}>Are you sure you want to change pool <mark>{poolName}</mark> <br/> <b>Manual</b> status to {newStatus}?
          </div>
        )

      const color = this.isManuallyOfflineNow() ? 'primary': 'danger'
      const primaryButton = <Button color={color} onClick={this.manuallyChangePoolStatus}>{capitalizeFirstLetter(newStatus)}</Button>

      return <ModalComponent
        isOpen={this.props.isOpen}
        body={body}
        toggle={this.props.hideModal}
        dialogClassName={showManualOverrideWarning ? 'manual-status-warning-dialog' : undefined}
        primaryButton={primaryButton} />
    }

    return null
  }
}

const mapStateToProps = state => {
  return {
    isOpen: state.modal.isOpen,
    modalType: state.modal.modalType,
    poolId: state.poolDetails.id,
    poolName: state.poolDetails.poolName,
    offlineEvents: state.poolDetails.offlineEvents
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  hideModal,
  manuallyChangePoolStatus
}, dispatch)

ManuallyChangePoolStatusModal.propTypes = {
  isOpen: PropTypes.bool,
  modalType: PropTypes.string,
  poolId: PropTypes.string,
  poolName: PropTypes.string,
  offlineEvents: PropTypes.arrayOf(PropTypes.object),
  hideModal: PropTypes.func,
  manuallyChangePoolStatus: PropTypes.func
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManuallyChangePoolStatusModal)



// WEBPACK FOOTER //
// ./src/containers/modal/manuallyChangePoolStatus.js